<template>
  <div class="communication-board-detail" v-if="Object.keys(funcView).length">
    <div class="header">
      <i class="icon icon-fanhuijiantou" @click="jump($route.query.parentPath)"></i>
      <div class="title">
        <span>{{ type === 'batteryManagement' ? boardInfo.batterySn : boardInfo.modemSn }}</span>
        <span v-if="deviceInfo.productCode">（{{ deviceInfo.productCode }}）</span>
      </div>
      <div class="func-group">
        <template v-for="item in ParamGroupTree">
          <el-button
            plain
            v-if="
              (item.componentCode === 'commonConfig' && funcView.boardDetail_commonConfig) ||
              (item.componentCode === 'service' && funcView.boardDetail_service) ||
              (item.componentCode === 'otherConfig' && funcView.boardDetail_otherConfig)
            "
            :key="item.componentCode"
            @click="handleParamList(item.componentCode, item.componentName, item.componentGroup, item.componentDesc)"
          >
            <span class="btn-text" :code="item.componentCode">{{ item.componentName }}</span>
          </el-button>
        </template>
      </div>
    </div>
    <div class="page-content clear">
      <div class="device-param">
        <div class="header">
          <div class="device-sn">{{ testType === '9' ? $t('dms_boardDetail.zheng_ji_ce_shi') : $t('dms_boardDetail.dian_chi_xin_xi') }}</div>
        </div>
        <ul class="param-detail">
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.zai_xian') }}</div>
              <div class="val">{{ getDicValue('isynergy_cloud_bool', boardInfo.isOnline) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.zhlxsj') }}</div>
              <div class="val">{{ momentAmPm($momentLocal(boardInfo.lastOnlineTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="type === 'entire' || type === 'batteryManagement'">
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.chan_pinSN') }}</div>
              <div class="val">{{ boardInfo.productSn || '-' }}</div>
            </div>
          </li>
          <li v-if="type === 'entire' || type === 'batteryManagement'">
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.chan_pin_xing_hao') }}</div>
              <div class="val">{{ boardInfo.productCode || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ 'Modem SN' }}</div>
              <div class="val">{{ boardInfo.modemSn || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.Modemxing_hao') }}</div>
              <div class="val">{{ boardInfo.modemModel || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.Modemruan_jian') }}</div>
              <div class="val">{{ boardInfo.modemFwVersion || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.Modemying_jian') }}</div>
              <div class="val">{{ boardInfo.modemHwVersion || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.dian_chiSN') }}</div>
              <div class="val">{{ boardInfo.batterySn || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.dian_chi_xing_hao') }}</div>
              <div class="val">{{ boardInfo.batteryModel || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.dian_chi_ruan_jian') }}</div>
              <div class="val">{{ boardInfo.batteryFwVersion || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.dian_chi_ying_jian') }}</div>
              <div class="val">{{ boardInfo.batteryHwVersion || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.sheng_yu_dian_liang') }}</div>
              <div class="val">{{ boardInfo.batteryCharge || '-' }}</div>
            </div>
          </li>
          <li v-if="type !== 'batteryManagement'">
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.dcsjgxsj') }}</div>
              <div class="val">{{ momentAmPm($momentLocal(boardInfo.lastDataUpdateTime) || '-') }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.sheng_dian') }}</div>
              <div class="val">{{ getDicValue('isynergy_cloud_bool', boardInfo.isPowerSave) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.ISTzhan_dian') }}</div>
              <div class="val">{{ getWebsiteName(boardInfo) }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.zhan_dian_zhuang_tai') }}</div>
              <div class="val">{{ getDicValue('website_state', boardInfo.websiteState) || '-' }}</div>
            </div>
          </li>
          <li v-if="type !== 'batteryManagement'">
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.ce_shi_zhuang_tai') }}</div>
              <div class="val">{{ getDicValue('dms_test_state', boardInfo.testState) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('dms_boardDetail.xie_yi_lei_bie') }}</div>
              <div class="val">{{ getDicValue('iot_protocol_class', boardInfo.protocolClass) || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                <!-- {{ $t('label_protocol_version }} -->
                {{ $t('dms_boardDetail.xie_yi_ji_ban_ben') }}
              </div>
              <div class="val">{{ boardInfo.protocolCode || '-' }}/{{ boardInfo.tcpVersion || '-' }}</div>
            </div>
          </li>
          <li v-if="type === 'batteryManagement'">
            <div class="content">
              <div class="key">
                <!-- {{ $t('label_protocol_version }} -->
                {{ $t('dms_boardDetail.ji_shen_hao') }}
              </div>
              <div class="val">{{ boardInfo.bodyNum || '-' }}</div>
            </div>
          </li>
          <li v-if="type === 'batteryManagement'">
            <div class="content">
              <div class="key">
                <!-- {{ $t('label_protocol_version }} -->
                {{ $t('dms_boardDetail.geng_xin_shi_jian') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(boardInfo.gmtModified)) }}</div>
            </div>
          </li>
          <!-- <li>
            <div class="content">
              <div class="key">{{ $t('label_bodyNum }}</div>
              <div class="val"></div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('label_stock_inTime }}</div>
              <div class="val"></div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">{{ $t('lanel_stock_orderSn }}</div>
              <div class="val"></div>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="tab-content">
        <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
        <!-- 测试报告 -->
        <report v-if="tabIndex === 0 && boardInfo.modemSn" :deviceInfo="boardInfo"></report>
        <!-- 部件状态 -->
        <status v-if="tabIndex === 1" :modemSn="boardInfo.modemSn" ref="status"></status>
        <!-- 事件记录 -->
        <event v-if="tabIndex === 2" :deviceInfo="boardInfo" :isModem="true"></event>
        <!-- 地理位置 -->
        <location v-if="tabIndex === 3" :deviceInfo="boardInfo"></location>
      </div>
    </div>
    <!-- 参数配置 -->
    <device-param-drawer v-if="dialogVisible" :data="dialogData" :model="dialogModel" :funView="funcView" @close="dialogVisible = false" ></device-param-drawer>
    <!-- 设备控制中心 -->
    <device-control-drawer v-if="dialogVisible2" :data="dialogData2" :model="dialogModel2" @close="dialogVisible2 = false"></device-control-drawer>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import report from '@/pages/dms/components/device_detail_report.vue';
import deviceParamDrawer from '@/pages/dms/components/deviceParamModemDrawer';
import deviceControlDrawer from '@/pages/dms/components/deviceControlModemDrawer';
import event from '@/pages/dms/components/device_detail_event.vue';
import status from './children/board_detail_status.vue';
import location from './children/board_detail_location.vue';

export default {
  name: 'boardDetail',
  components: {
    status,
    report,
    deviceParamDrawer,
    deviceControlDrawer,
    location,
    event,
  },
  computed: {
    tabData() {
      const arr = [];
      if (this.funcView.boardDetail_testReport) {
        arr.push({
          name: this.$t('dms_boardDetail.ce_shi_bao_gao'),
          value: 0,
        });
      }
      if (this.funcView.boardDetail_deviceStatus) {
        arr.push({
          name: this.$t('dms_boardDetail.bu_jian_zhuang_tai'),
          value: 1,
        });
      }
      if (this.funcView.boardDetail_event) {
        arr.push({
          name: this.$t('dms_boardDetail.shi_jian_ji_lu'),
          value: 2,
        });
      }
      if (this.funcView.boardDetail_location) {
        arr.push({
          name: this.$t('dms_boardDetail.wei_zhi_xin_xi'),
          value: 3,
        });
      }
      return arr;
    },
  },
  watch: {
    tabData: {
      immediate: false,
      handler(val) {
        if (val && val.length && this.tabIndex === '') {
          this.tabIndex = this.tabData[0].value;
        }
      },
    },
  },
  data() {
    return {
      provide: true,
      deviceId: '',
      modemSn: '',
      batterySn: '',
      deviceInfo: {},
      boardInfo: {},
      tabIndex: '',
      ParamGroupTree: [],
      bodyNum: '',
      // 参数设置
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},

      dialogVisible2: false,
      dialogData2: {},
      dialogModel2: {},
      type: '',
      testType: '', // 测试类型:1-电池，9-整机
      // IST 站点列表
      istList: [],
    };
  },
  mounted() {
    this.deviceId = this.getJump('deviceId');
    this.modemSn = this.getJump('modemSn');
    this.batterySn = this.getJump('batterySn');
    this.type = this.getJump('type');
    this.testType = this.getJump('testType') || '1';

    this.initIstList();

    this.getFuncView('/boarddetail');
    this.getBoardInfo();
    this.getParamGroupTree();
  },
  methods: {
    initIstList() {
      const reqUrl = apis.websiteSelectList;
      const reqData = { websiteEnv: this.websiteEnv, websiteType: 1 };
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.istList = res.data || [];
      });
    },
    getWebsiteName(row) {
      const istList = this.istList;
      if (istList.length) {
        const item = istList.find(obj => obj.websiteCode === row.websiteCode);
        if (item) {
          return item.websiteName;
        }
      }
      return row.websiteName || '-';
    },
    // 通过groupCode 查询参数
    handleParamList(componentCode, componentName, componentGroup, componentDesc) {
      if (componentGroup === 3) {
        this.$getJSON(apis.modemBatteryRefresh, {
          modemSn: this.modemSn,
          componentCode,
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          // this.getDeviceInfo();
          if (this.tabIndex === 0) {
            this.$refs.status.udpate();
          }
        });
        return;
      }
      // 控制中心
      if (componentGroup === 2) {
        this.dialogVisible2 = true;
        this.dialogModel2.title = componentName;
        this.dialogModel2.desc = componentDesc;
        this.dialogModel2.type = 'edit';
        this.dialogData2.modemSn = this.modemSn;
        this.dialogData2.componentCode = componentCode;
        this.dialogData2.componentGroup = componentGroup;
        this.dialogData2.testType = this.testType;
      } else {
        this.dialogVisible = true;
        this.dialogModel.title = componentName;
        this.dialogModel.desc = componentDesc;
        this.dialogModel.type = 'edit';
        this.dialogData.modemSn = this.modemSn;
        this.dialogData.componentCode = componentCode;
        this.dialogData.componentGroup = componentGroup;
        this.dialogData.testType = this.testType;
      }
    },
    // 查询参数分组树
    getParamGroupTree: function () {
      this.$getJSON(apis.modemBatteryParamGrouplist, {
        modemSn: this.modemSn,
        testType: this.testType,
      }).then((res) => {
        this.ParamGroupTree = res.data;
      });
    },
    // 获取设备信息
    // getDeviceInfo() {
    //   this.$getJSON(`${apis.DeviceInfo}/${this.deviceId}`).then((res) => {
    //     this.deviceInfo = res.data;
    //     // this.modemSn = res.data.modemSn;
    //     this.getParamGroupTree();
    //   });
    // },
    // 通讯板详情
    getBoardInfo() {
      //  测试类型:1-电池，9-整机

      this.$getJSON(apis.modemBatteryInfo, {
        modemSn: this.modemSn,
      }).then((res) => {
        this.boardInfo = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.communication-board-detail {
  padding: 0 16px 16px;
  height: 100%;

  .icon-fanhuijiantou {
    color: #394668;
    &:hover {
      cursor: pointer;
    }
  }

  > .header {
    padding: 24px 0 16px 0;
    height: 68px;
    overflow: hidden;
    .icon {
      font-size: 16px;
      float: left;
      line-height: 30px;
      font-weight: bold;
    }
    .title {
      float: left;
      margin-left: 18px;
      color: #394668;
      font-size: 18px;
      line-height: 32px;
      &:hover {
        cursor: pointer;
      }
    }

    .func-group {
      float: right;

      .btn-text {
        line-height: 24px;
        // padding-right: 14px;
      }

      .icon-xiala {
        color: #0d9ae0;
      }

      .el-dropdown {
        float: left;
      }

      .el-button {
        float: left;
        margin-left: 8px;
      }
    }
  }

  .page-content {
    width: 100%;
    height: calc(100% - 68px);
    overflow: hidden;
    .device-param {
      width: 300px;
      background: #fff;
      padding: 0 24px;
      float: left;
      margin-right: 16px;
      height: 100%;
      overflow-y: auto;
      .header {
        height: 40px;
        position: relative;
        .device-sn {
          float: left;
          color: #495057;
          font-size: 14px;
          font-weight: bold;
          line-height: 24px;
          margin-top: 16px;
          margin-left: -8px;
        }
        .device-state {
          position: absolute;
          top: 16px;
          right: -8px;
          .device-state-tag {
            $r: 24px;
            width: $r;
            height: $r;
            border-radius: $r / 2;
            background: rgba(13, 154, 224, 0.05);
            overflow: hidden;
            float: left;
            &.has-name {
              width: auto;
              padding-right: 10px;
              line-height: $r;
              .icon {
                margin-left: 9px;

                &.icon-cleaning,
                &.icon-free {
                  font-size: 18px;
                }

                &.icon-cleaning {
                  margin-top: 5px;
                }
                &.icon-suspend,
                &.icon-free,
                &.icon-charge {
                  margin-top: 4px;
                }

                &.icon-machine-offline {
                  margin-top: 5px;
                  font-size: 18px;
                }
              }
            }
            &:nth-child(n + 2) {
              margin-left: 6px;
            }

            .icon {
              $r: 18px;
              width: $r;
              height: $r;
              text-align: center;
              line-height: $r;
              float: left;
              margin-top: 3px;
              margin-left: 3px;
              font-size: 14px;

              // &.icon-machine-offline,

              &.blue {
                color: #0d9ae0;
              }

              &.red {
                color: #ff5c5b;
              }
              &.yellow {
                color: #f99751;
              }
              &.gray {
                color: #6d757d;
              }
              &.green {
                color: #16d071;
              }
            }

            .state-name {
              float: left;
              font-size: 12px;
              color: #495057;
              margin-left: 3px;
            }
          }
        }
      }

      .device-img {
        &.gray {
          background: #f5f5f5;
        }
        $r: 160px;
        width: $r;
        height: $r;
        margin: 24px auto 0 auto;
        position: relative;

        &.offline {
          /** 图片去色 */
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
        }

        > img {
          position: absolute;
          max-width: 100%;
          max-height: 100%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }

      .device-status-container {
        text-align: center;
        font-size: 0;
        .device-status {
          font-size: 12px;
          color: #4d4d4d;
          margin-top: 24px;
          overflow: hidden;
          display: inline-block;

          > li {
            float: left;
            &:nth-child(n + 2) {
              margin-left: 16px;
            }
            &.signal {
              .val {
                padding-left: 2px;
              }
            }
            .key {
              float: left;
              color: #16d071;
              .icon {
                float: left;
                font-size: 14px;
                line-height: 24px;
              }
            }
            .val {
              float: left;
              margin-left: 2px;
              line-height: 23px;
            }
          }
        }
      }

      .param-detail {
        margin-top: 24px;
        color: #6c757d;
        font-size: 12px;

        // min-height: 500px;
        > li {
          padding: 8px 0 7px 0;
          border-bottom: 1px solid #eef2f7;
          .content {
            overflow: hidden;
            line-height: 18px;
            .key {
              width: 50%;
              float: left;
            }
            .val {
              float: right;
              width: 50%;
              text-align: right;
              word-break: break-all;
            }
          }
        }
      }
    }

    .tab-content {
      // overflow: hidden;
      background: #fff;
      margin-bottom: 15px;
      overflow-y: auto;
      max-height: 100%;
      &.mapbox {
        height: calc(100% - 84px);
        min-height: 789px;
        position: absolute;
        top: 68px;
        left: 332px;
        right: 16px;
      }
    }
  }
}
</style>
